/* ============================================================
   rewards-widget.js  —  assets/
   Floating rewards panel — works on every page
   ============================================================ */

(function () {
  'use strict';

  const root    = document.getElementById('rw-root');
  if (!root) return;

  const customerId = root.dataset.customerId;
  const isLoggedIn = !!customerId;
  const PROXY      = '/apps/rewards';

  const fab      = document.getElementById('rw-fab');
  const panel    = document.getElementById('rw-panel');
  const backdrop = document.getElementById('rw-backdrop');
  const badge    = document.getElementById('rw-fab-badge');
  const balNum   = document.getElementById('rw-balance-num');
  const earnBar  = document.getElementById('rw-earn-bar');
  const earnTxt  = document.getElementById('rw-earn-txt');
  const history  = document.getElementById('rw-history');

  let isOpen    = false;
  let loaded    = false;
  let balance   = 0;

  /* ── Toggle panel ── */
  fab.addEventListener('click', () => { isOpen ? close() : open(); });
  backdrop.addEventListener('click', close);
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && isOpen) close();
  });

  // Guest: toggle works, but no API fetch needed
  if (!isLoggedIn) return;

  /* ── Birthday popup ── */
  const bdayPopup   = document.getElementById('rw-bday-popup');
  const bdayOverlay = document.getElementById('rw-bday-overlay');
  const bdayInput   = document.getElementById('rw-bday-input');
  const bdayError   = document.getElementById('rw-bday-error');
  const bdaySave    = document.getElementById('rw-bday-save');
  const bdayClose   = document.getElementById('rw-bday-close');
  const bdaySkip    = document.getElementById('rw-bday-skip');

  function showBdayPopup() {
    if (!bdayPopup) return;
    bdayPopup.style.display = 'block';
    bdayOverlay.classList.add('rw-open');
    // Trigger transition on next frame
    requestAnimationFrame(() => {
      requestAnimationFrame(() => bdayPopup.classList.add('rw-open'));
    });
  }

  function hideBdayPopup() {
    if (!bdayPopup) return;
    bdayPopup.classList.remove('rw-open');
    bdayOverlay.classList.remove('rw-open');
    setTimeout(() => { bdayPopup.style.display = 'none'; }, 300);
  }

  if (bdayClose)   bdayClose.addEventListener('click', hideBdayPopup);
  if (bdayOverlay) bdayOverlay.addEventListener('click', hideBdayPopup);
  if (bdaySkip) bdaySkip.addEventListener('click', hideBdayPopup);

  if (bdaySave) {
    bdaySave.addEventListener('click', async () => {
      const val = bdayInput?.value;
      if (!val) {
        bdayError.textContent = 'Please enter your date of birth.';
        bdayError.style.display = 'block';
        return;
      }

      bdayError.style.display = 'none';
      bdaySave.disabled       = true;
      bdaySave.textContent    = 'Saving…';

      try {
        const res = await fetch(`${PROXY}/save-birthday`, {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body:    JSON.stringify({ customer_id: customerId, birthday: val })
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.error || 'Failed to save');

        bdaySave.textContent = '🎂 Saved!';
        setTimeout(hideBdayPopup, 1200);
      } catch (e) {
        bdayError.textContent   = e.message || 'Something went wrong. Please try again.';
        bdayError.style.display = 'block';
        bdaySave.disabled       = false;
        bdaySave.textContent    = 'Save Birthday';
      }
    });
  }

  function open() {
    isOpen = true;
    fab.classList.add('rw-fab--open');
    fab.setAttribute('aria-expanded', 'true');
    panel.classList.add('rw-open');
    panel.setAttribute('aria-hidden', 'false');
    backdrop.classList.add('rw-open');

    if (!loaded) {
      loaded = true;
      fetchPoints();
    }
  }

  // Fetch points immediately on page load (not just on widget open)
  // This allows birthday popup to show right after login without needing to open the widget
  (function checkBirthdayOnLoad() {
    const BDAY_SESSION_KEY = `rw_bday_shown_${customerId}`;
    if (sessionStorage.getItem(BDAY_SESSION_KEY)) return; // already shown this session

    fetch(`${PROXY}/points?customer_id=${customerId}`)
      .then(r => r.json())
      .then(data => {
        if (!data.has_birthday) {
          sessionStorage.setItem(BDAY_SESSION_KEY, '1');
          setTimeout(showBdayPopup, 1000);
        }
      })
      .catch(() => {}); // silent fail — widget will retry when opened
  })();

  function close() {
    isOpen = false;
    fab.classList.remove('rw-fab--open');
    fab.setAttribute('aria-expanded', 'false');
    panel.classList.remove('rw-open');
    panel.setAttribute('aria-hidden', 'true');
    backdrop.classList.remove('rw-open');
  }

  /* ── Fetch points + history ── */
  async function fetchPoints() {
    try {
      const res  = await fetch(`${PROXY}/points?customer_id=${customerId}`);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();

      balance = data.balance || 0;
      const hist          = data.history || [];
      const isFirstOrder  = data.is_first_order ?? true;

      // Balance display
      balNum.textContent = balance.toLocaleString('en-IN');

      // Badge on FAB
      if (balance > 0) {
        badge.textContent = balance > 999
          ? Math.floor(balance / 1000) + 'k'
          : balance.toLocaleString('en-IN');
        badge.style.display = 'flex';
      }

      // Birthday popup already handled by checkBirthdayOnLoad()
      // Just update the widget row state here

      // Birthday compact row — "Add" button opens popup
      const widgetBdayRow     = document.getElementById('rw-widget-bday-row');
      const widgetBdaySub     = document.getElementById('rw-widget-bday-sub');
      const widgetBdayTrigger = document.getElementById('rw-widget-bday-trigger');

      if (widgetBdayRow) {
        if (data.has_birthday) {
          widgetBdayRow.classList.add('rw-panel__bday-row--saved');
          widgetBdaySub.textContent = '🎂 Birthday saved — 100 pts every year';
        } else {
          // "Add" opens the birthday popup
          if (widgetBdayTrigger) {
            widgetBdayTrigger.addEventListener('click', () => {
              close(); // close widget panel first
              setTimeout(showBdayPopup, 200);
            });
          }
        }
      }

      // Earn bar — show on product/collection pages (not cart)
      const onCart = window.location.pathname.includes('/cart');
      if (!onCart) {
        const productPrice = getProductPrice();
        if (productPrice > 0) {
          const earn = isFirstOrder
            ? Math.floor(productPrice / 200)
            : Math.floor(productPrice / 10000);
          earnTxt.textContent = `Earn ${earn.toLocaleString('en-IN')} pts on this purchase`;
          earnBar.style.display = 'flex';
        }
      }

      // History
      renderHistory(hist);

    } catch (e) {
      console.error('[RewardsWidget]', e);
      balNum.textContent = '—';
      history.innerHTML = '<div class="rw-panel__empty">Could not load points.</div>';
    }
  }

  /* ── Render history ── */
  function renderHistory(hist) {
    if (!hist.length) {
      history.innerHTML = '<div class="rw-panel__empty">No activity yet.</div>';
      return;
    }
    history.innerHTML = hist.slice(0, 10).map((h, i) => {
      const isEarn = h.type === 'earn';
      const pts    = Math.abs(h.points);

      // Simple human-readable label
      let label;
      if (h.is_expiry)       label = 'Points expired';
      else if (h.is_welcome) label = 'Welcome bonus';
      else if (h.is_manual)  label = h.description;
      else if (isEarn)       label = `${pts.toLocaleString('en-IN')} pts earned on purchase`;
      else                   label = `${pts.toLocaleString('en-IN')} pts redeemed`;

      return `<div class="rw-hist-item" style="animation-delay:${i * 40}ms">
        <span class="rw-hist-dot rw-hist-dot--${isEarn ? 'earn' : 'use'}"></span>
        <span class="rw-hist-desc">${esc(label)}</span>
        <span class="rw-hist-pts rw-hist-pts--${isEarn ? 'earn' : 'use'}">
          ${isEarn ? '+' : '−'}${pts.toLocaleString('en-IN')}
        </span>
      </div>`;
    }).join('');
  }

  /* ── Try to get current product price for earn preview ── */
  function getProductPrice() {
    // Shopify sets window.ShopifyAnalytics or meta tags with product price
    try {
      if (window.ShopifyAnalytics?.meta?.product?.variants?.[0]?.price) {
        return window.ShopifyAnalytics.meta.product.variants[0].price; // paise
      }
      // Try reading from a price element on the page
      const priceEl = document.querySelector('[data-product-price], .price__regular .money, .price-item--regular');
      if (priceEl) {
        const text  = priceEl.textContent.replace(/[^\d.]/g, '');
        const rupees = parseFloat(text);
        return isNaN(rupees) ? 0 : Math.round(rupees * 100); // convert to paise
      }
    } catch {}
    return 0;
  }

  function esc(s) {
    return String(s)
      .replace(/&/g,'&amp;').replace(/</g,'&lt;')
      .replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

})();